<i class="fa fa-caret-right caret-expander p-0 m-0" [class.expanded]="isExpanded" [attr.aria-expanded]="isExpanded"></i>
